/*=========================================================================================
  File Name: state.js
  Description: Cart State
  ----------------------------------------------------------------------------------------
  Item Name: FoodiGo
  Author: Tan Tran
========================================================================================== */
/*=========================================================================================
  File Name: state.js
  Description: Cart State
  ----------------------------------------------------------------------------------------
  Item Name: Fujisushi Web app
  Author: Tan Tran
========================================================================================== */

export default {
  favouriteItems: []
}
